<template>
    <div >

        <!-- 1) title -->
        <div class="TQ_margin_bottom_8px " >
            <div class="TQ_inline TQ_margin_4px TQ_borderBox TQ_maxWidth_200px TQ_width_100p">

                <div class="TQ_text_bold TQ_margin_bottom_4px ">
                    {{ass_strings.oneWord_name[p_store_systemLangCode_e] }}
                </div>

                <div>
                    <input class="TQ_padding_8px TQ_center TQ_borderBox TQ_width_100p" :placeholder="ass_strings.oneWord_name[p_store_systemLangCode_e]" v-model="p_whiteLabel_c.wl_title_s"/>
                </div>
            </div>

        </div>

        <!-- 2) logo -->
        <div class="TQ_margin_bottom_4px" >
            <div class="TQ_text_bold TQ_margin_bottom_4px TQ_inline">
                {{ass_strings.oneWord_logo[p_store_systemLangCode_e] }} (svg)
            </div>
            <br>

            <tq-image :pb_src_r="p_whiteLabel_c.wl_logoUrl_s || ass_img_image" 
                @click.native="() => popup_chooseFile_show_vb.val = true"
                class="TQ_maxWidth_200px TQ_clickable  TQ_borderBox TQ_border_gray TQ_padding_16px TQ_borderRadius "/>


            <!-- Choose file -->
            <tq-popup :show="popup_chooseFile_show_vb" width="100%" p_height_s="100vh" class="TQ_center" padding="0" :show-close-btn="true">
                <fcuc-drive
                    :p_can-choose-image_b="true"
                    :p_can-choose-video_b="false"
                    :p_can-choose-audio_b="false"
                    :pe_choose-file_f="m_selectImage_f"
                />
            </tq-popup>

        </div>

        <!-- 3) colors -->
        <div>
            <!-- 3.1) text color -->
            <div class="TQ_inline TQ_margin_8px">
                <div class="TQ_text_bold TQ_align_initial TQ_margin_bottom_4px TQ_inline">
                    {{ass_strings.twoWords_textColor[p_store_systemLangCode_e] }}
                </div>
                <br>

                <tq-pick-color :p_system-lang-code_e="p_store_systemLangCode_e"
                                    :pe_change-color_s="(newColor_s) => {p_whiteLabel_c.wl_color_s=newColor_s}"
                                    class="TQ_inline TQ_verticalAlignTop TQ_center"
                                    :p_init-color_s="p_whiteLabel_c.wl_color_s">
                    <div class="TQ_padding_2px TQ_width_60px TQ_height_60px TQ_inline TQ_margin_2px TQ_clickable TQ_box_shadow TQ_borderRadius " :style="{background: p_whiteLabel_c.wl_color_s}" >
                    </div>
                </tq-pick-color>
            </div>

            <!-- 3.2) color background -->
            <div class="TQ_inline TQ_margin_8px" >
                <div class="TQ_text_bold TQ_align_initial TQ_margin_bottom_4px TQ_inline">
                    {{ass_strings.twoWords_backgroundColor[p_store_systemLangCode_e] }}
                </div>
                <br>

                <tq-pick-color :p_system-lang-code_e="p_store_systemLangCode_e"
                                    :pe_change-color_s="(newColor_s) => {p_whiteLabel_c.wl_backgroundColor_s=newColor_s}"
                                    class="TQ_inline TQ_verticalAlignTop TQ_center"
                                    :p_init-color_s="p_whiteLabel_c.wl_backgroundColor_s">
                    <div class="TQ_padding_2px TQ_width_60px TQ_height_60px TQ_inline TQ_margin_2px TQ_clickable TQ_box_shadow TQ_borderRadius " :style="{background: p_whiteLabel_c.wl_backgroundColor_s}" >
                    </div>
                </tq-pick-color>
            </div>

        </div>


    </div>

</template>

<script>
import { FB_WhiteLabel } from '../../../functions/src/shareCode/Share_S_Classes'
import FcucDrive from '@/components/unpure/FcucDrive.vue'
import TqImage from '@/components/basic/TqImage.vue'
import {ass_strings} from "../../../functions/src/shareCode/Share_Ass_Dictionary";
import { notification_notify2 } from '@/scripts/S_Notification';
import TqPopup from '@/components/basic/TqPopup.vue';
import { ass_img_image } from '@/assets/scripts/Ass_Files';
import TqPickColor from '@/components/basic2/TqPickColor.vue';
import { format_langCode_fs } from '../../../functions/src/shareCode/Share_S_Format';
export default {
  components: { FcucDrive, TqImage, TqPopup, TqPickColor },
    name: "TqEditCompany",
    props:{
        p_store_systemLangCode_e:{
            type :String,
            require: true,
        },
        p_whiteLabel_c: {
            type: FB_WhiteLabel,
            require: true
        }
    },
    data(){
        return {
            popup_chooseFile_show_vb : {val : false},
            
            // imports 
            ass_strings,
            ass_img_image,
            format_langCode_fs
        }
    },
    methods:{
        m_selectImage_f(image_c){
                
            if(!image_c.fi_m_isSvg_fb()){
                notification_notify2({
                    title_s : ass_strings.oneWord_error,
                    text_s: 'not an svg file'
                }) 
                return
            }
            this.popup_chooseFile_show_vb.val = false
            this.p_whiteLabel_c.wl_logoUrl_s = image_c.fi_url_s
                        
        },
    }
}
</script>

<style>
</style>